export default __webpack_public_path__ + "4581c66ee707fa48914b49ee115853dc.svg";